// ----------------------------------------------------------------------------
// Component: Blog Article Quote
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_blog-article-quote.scss';
